document.addEventListener("DOMContentLoaded", () => {
    var show_more = document.querySelector(".product-load-more");
    show_more.addEventListener("click", () => {
        var paginate_by = show_more.dataset.paginate;
        var click_count = show_more.dataset.click;
        var type = show_more.dataset.type;
        if(type == "show"){
            show_more.setAttribute("data-click", parseInt(click_count) + 1);
            var show_index = (parseInt(click_count) + 1) * paginate_by;
            var product_items = document.querySelectorAll(".collection--section .productgrid--items .productgrid--item.product-grid-item--hidden");
            if(product_items.length > 0){
                product_items.forEach(item => {
                    if(item.dataset.index <= show_index) {
                        item.classList.remove("product-grid-item--hidden");
                    }
                })
            }
            if(product_items.length == 0 || product_items.length < paginate_by) {
                show_more.setAttribute("data-type", "less");
                show_more.innerHTML = "Załaduj mniej";
                return;
            }
        }else if(type == "less") {
            show_more.setAttribute("data-click", parseInt(click_count) - 1);
            var show_index = (parseInt(click_count) - 1) * paginate_by;
            var product_items = document.querySelectorAll(".collection--section .productgrid--items .productgrid--item");
            product_items.forEach(item => {
                if(item.dataset.index > show_index){
                    item.classList.add("product-grid-item--hidden");
                }
            })
            if(click_count == 2) {
                show_more.setAttribute("data-type", "show");
                show_more.innerHTML = "Załaduj więcej";
                return;
            }
        }
    })
})